import { UIWidgetsDiv } from "../division/Division";
import styled from "styled-components";
import { Column } from "../../grids/Grids";

const margin10 = `10px`;
const margin60 = `60px`;
const margin174 = `174px`;
const padding13 = `13px`;
const padding18 = `18px`;
const padding20 = `20px`;
const padding30 = `30px`;
const minWidth = `78px`;
const height100Vh = `100vh`;

export const DialogBoxWrapper = styled(UIWidgetsDiv).attrs({
  name: "dialog-box"
})`
  /* ${({ isOpen }) => !isOpen && `display: none`} */
  /* display: none; */
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  align-items: center;
  overflow: auto;
  > div:first-child {
    opacity: 0;
    position: absolute;
    width: 100%;
    height: 100%;
  }
`;
export const ContentWrapper = styled(Column).attrs({ name: "content-wrapper" })`
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  max-height: ${height100Vh};
  height: ${props =>
    props.scrollable ? `calc(${height100Vh} - ${margin60})` : `auto`};
  background: ${props => props.theme.brandWhite};
  > :first-child {
    padding: ${props =>
      props.scrollable
        ? `${padding20} ${padding30} ${padding18} ${padding30}`
        : `${padding30} ${padding30} ${padding20} ${padding30}`};
    ${({ scrollable, theme }) =>
      scrollable && `border-bottom: 1px solid ${theme.borderBottom}`};
  }
  > div:nth-child(2) {
    padding: 0 ${padding30} 0 ${padding30};
    justify-content: flex-start;
    ${({ scrollable }) =>
      scrollable &&
      `height: calc(${height100Vh} - ${margin174}); overflow-y: scroll`};
  }
  > div:nth-child(3) {
    padding: ${props =>
      props.scrollable
        ? `${padding13} ${padding30} ${padding13} ${padding30}`
        : `${padding20} ${padding30} ${padding30} ${padding30}`};
    ${({ scrollable, theme }) =>
      scrollable && `border-top: 1px solid ${theme.borderBottom}`};
  }
`;
export const DialogHeader = styled(UIWidgetsDiv).attrs({
  name: "dialog-header"
})`
  line-height: ${props => props.theme.lineHeight18};
  font-size: ${props => props.theme.font18};
  color: ${props => props.theme.darkGrey};
  font-family: ${props => props.theme.font_family};
  font-weight: ${props => props.theme.fontBold};
`;
export const ButtonsRegionWrapper = styled(UIWidgetsDiv).attrs({
  name: "buttons-region"
})`
  justify-content: flex-end;
  flex-direction: row;
  > button {
    font-family: ${props => props.theme.font_family};
    min-width: ${minWidth};
    height: auto;
  }
  > button:not(:first-child) {
    margin-left: ${margin10};
  }
`;
